import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { modeKeys } from './modeKeys';
import { type TenantMode, tenantModeSchema } from './useTenantMode';

// Switches the tenant's operating mode. Going live is gated server-side by the
// Console production flag — a 403 surfaces as the caller's onError.
export function useSetTenantMode() {
  const tenantId = useTenantStore((s) => s.tenantId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mode: 'test' | 'live'): Promise<TenantMode> => {
      const raw = await apiClient.put(`api/v1/t/${tenantId}/mode`, { json: { mode } }).json();
      return tenantModeSchema.parse(raw);
    },
    onSuccess: (data) => {
      if (tenantId) {
        queryClient.setQueryData(modeKeys.detail(tenantId), data);
      }
    },
  });
}
